export default function SocialField({
  icon,
  alt,
  value,
  handleInput,
  name,
  placeholder,
}) {
  return (
    <>
      <div className="form-group form-group-social">
        <div className="profile-edit-icon-wrapper">
          <div className="profile-edit-icon-wrapper__img profile-edit-icon-wrapper__img">
            <img src={icon} alt={alt} />
          </div>
          <input
            type="url"
            name={name}
            value={value}
            onChange={handleInput}
            placeholder={placeholder}
          />
        </div>
      </div>
    </>
  );
}
